import {
  DocumentSection,
  EntityDocument,
  ManagementQuote,
} from '@toggle/toggle';
import React from 'react';

import { Markdown } from '~/components/markdown/Markdown';
import { useDocuments } from '~/hooks/use-documents-entity/useDocumentsEntity';

import * as S from './ManagementCitations.styles';

export interface CitationsProps {
  citations: (DocumentSection & ManagementQuote)[];
  onClick: (citationId: string, document: EntityDocument) => void;
  activeIdx?: number;
}

export const ManagementCitations = ({
  citations,
  onClick,
  activeIdx,
}: CitationsProps) => {
  const { data } = useDocuments(citations.map(c => c.document));

  return (
    <>
      {citations.map((citation, idx) => {
        const document = data.find(d => d?.id === citation.document);

        if (!document) {
          return null;
        }

        const { kind, period } = document;

        const nameLabel = citation.speaker_name ?? '';
        const titleLabel = citation.speaker_title ?? '';
        const firstPartLabel =
          nameLabel && titleLabel
            ? `${nameLabel} - ${titleLabel}`
            : `${nameLabel || titleLabel}`;
        const secondPartLabel = `${period.toUpperCase()} ${kind[0].toUpperCase()}${kind.slice(
          1
        )}`;

        return (
          <S.Container
            key={citation.id}
            onClick={() => onClick(citation.id, document)}
            $active={idx === activeIdx}
          >
            <S.MarkdownWrapper>
              <Markdown message={`"${citation.content}"`} />
            </S.MarkdownWrapper>
            <S.StyledLabel>{`${firstPartLabel} | ${secondPartLabel}`}</S.StyledLabel>
          </S.Container>
        );
      })}
    </>
  );
};
